<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>vpn_key</md-icon>
          </div>
          <md-toolbar class="fm-card-header">
            <h4 class="md-title">Your API Keys</h4>
            <help-link :link="helpLink.link"></help-link>
            <md-button
              class="md-simple"
              @click.native="handleNew()"
              data-tour="apikeys_new"
            >
              <md-icon>add_circle</md-icon>
              New
            </md-button>
          </md-toolbar>
        </md-card-header>
        <md-card-content>
          <loading-spinner
            v-if="loadingApiKey"
            title="API Keys"
            v-bind:loadingError="loadingError"></loading-spinner>
          <md-table
            v-if="!loadingApiKey"
            v-model="keysWithoutDefaultKey"
            class="table-striped table-hover"
          >
            <md-table-empty-state
              md-label="No API Keys Found"
              md-description="It looks like you have no API Keys. Go ahead and create one.">
              <md-button
                class="md-primary md-raised"
                @click="handleNew()"
                data-tour="apikeys_create"
              >
                <md-icon>add_circle</md-icon>
                Create
              </md-button>
            </md-table-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Tag" md-sort-by="tag">
                {{ item.tag }}
              </md-table-cell>
              <md-table-cell md-label="Key">{{ item.key }}</md-table-cell>
              <md-table-cell md-label="Actions" class="actions">
                <md-button
                  class="md-just-icon md-info md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
    <submit-snackbar
      v-bind:dirty="dirtyKeys"
      v-bind:errorsOccurred="submitErrorsOccurred"
      v-on:submit="updateConfig"
    ></submit-snackbar>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { get } from "vuex-pathify";
import _ from "lodash";
import ApiKeyModel from "@/models/apiKey";
import { HelpLinkTemplate, SubmitSnackbar, LoadingSpinner } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js'

export default {
  components: {
    SubmitSnackbar,
    LoadingSpinner,
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    dirtyKeys: false,
    currentKey: localStorage.apiKey, // The key currently in use by the console.
    loadingApiKey: true,
    loadingError: false,
    helpLink: helpLinks.apiKeys
  }),
  computed: {
    storeKeys: get("apiKeys/entities"),
    keysWithoutDefaultKey: {
      get() {
        return this.storeKeys;
      }
    },
    ogKeys: get("apiKeys/ogEntities"),
    submitErrorsOccurred: get("apiKeys/errorsOccurred")
  },
  created() {
    this.$store.dispatch("apiKeys/loadEntities")
      .then(() => {
        this.loadingApiKey = false;
      })
      .catch(ex => {
        this.loadingError = true;
      });
  },
  methods: {
    handleNew() {
      var newKey = new ApiKeyModel();

      swal
        .fire({
          title: `Create API Key`,
          input: "text",
          inputValue: newKey.tag,
          inputPlaceholder: "Tag",
          inputValidator: value => {
            if (!value) {
              return "You must provide a tag!";
            }
          },
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            newKey.tag = result.value;
            this.$store.dispatch("apiKeys/createEntity", newKey);
          }
        });
    },
    handleEdit(item) {
      var me = this;

      swal
        .fire({
          title: `Edit API Key`,
          input: "text",
          inputValue: item.tag,
          inputPlaceholder: "Tag",
          inputValidator: value => {
            if (!value) {
              return "You must provide a tag!";
            }
          },
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            item.tag = result.value;
            me.dirtyKeys = true;
          }
        });
    },
    handleDelete(item) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("apiKeys/deleteEntity", item.id).then(() => {
              swal.fire({
                title: "Deleted!",
                text: `You deleted ${item.tag}`,
                type: "success",
                confirmButtonClass: "md-button md-success btn-fill",
                buttonsStyling: false
              });
            });
          }
        });
    },
    updateConfig: function() {
      var me = this;

      var dirtyKeys = _.differenceWith(this.storeKeys, this.ogKeys, _.isEqual);
      if (dirtyKeys && dirtyKeys.length) {
        var doFinally = function(completed) {
          if (completed === dirtyKeys.length) {
            me.dirtyKeys = false;
          }
        };

        var completed = 0;
        dirtyKeys.forEach(key => {
          this.$store
            .dispatch("apiKeys/updateEntity", key)
            .then(() => {
              doFinally(++completed);
            })
            .catch(() => {
              doFinally(++completed);
            });
        });
      }
    }
  }
};
</script>